import React from "react";
import { HeaderGlobalAction } from "@carbon/react";
import { Help } from "@carbon/react/icons";
export const InfoButton = ({ onClick }) => (React.createElement(HeaderGlobalAction, { "aria-label": "Open Help Center", tooltipAlignment: "center", onClick: onClick },
    React.createElement(Help, { size: 20 })));
